module.exports = {
      id: "icons:home-usage",
      viewBox: "0 0 20 22",
      url: "/static/" + "sprites.9a613551d588b36f01fd88ce7dbef123.svg#icons:home-usage",
      toString: function () {
        return this.url;
      }
    }